import { usCities } from "../constants/cities";
import { emailRegex, phoneRegex, zipRegex } from "../constants/regex";
import { allStates } from "../constants/states";

type clinicDetails = {
  name(value: string): string;
  phone(value: string): string;
  street(value: string): string;
  state(value: string): string;
  city(value: string): string;
  zipcode(value: string): string;
  email(value: string): string;
};

export const validateClinicName = (value: string) => {
  if (value.length === 0) return "Please enter clinic name.";
  if (value.length < 3) return "Please enter a valid name.";

  return "";
};

export const validatePhoneNumber = (value: string) => {
  if (value.length === 0) return "Please enter phone number.";
  if (!phoneRegex.test(value)) return "Please provide valid number";
  else return "";
};

export const validateStreet = (value: string) => {
  if (value.length === 0) return "Please enter street name.";
  if (value.length < 3) return "Please enter a valid steet.";

  return "";
};

export const validateState = (value: string) => {
  if (value.length === 0) return "Please enter state.";
  if (!allStates.includes(value.toLocaleUpperCase()))
    return "Please enter a valid state.";

  return "";
};

export const validateCity = (value: string) => {
  if (value.length === 0) return "Please enter city.";
  if (!usCities.includes(value.toLocaleUpperCase()))
    return "Please enter a valid city.";

  return "";
};

export const validateZip = (value: string) => {
  if (value.length === 0) return "Please enter zipcode.";
  if (!zipRegex.test(value)) return "Enter a valid zipcode.";

  return "";
};

export const validateEmail = (value: string) => {
  if (value.length === 0) return "Please enter email.";
  if (!emailRegex.test(value)) return "Please enter a valid email.";
  return "";
};

const validator: clinicDetails = {
  name: validateClinicName,
  phone: validatePhoneNumber,
  street: validateStreet,
  state: validateState,
  city: validateCity,
  zipcode: validateZip,
  email: validateEmail,
};

export default validator;
